import { render, staticRenderFns } from "./KidsUpdateStatusDialog.vue?vue&type=template&id=d1711d2c&scoped=true"
import script from "./KidsUpdateStatusDialog.vue?vue&type=script&lang=js"
export * from "./KidsUpdateStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./KidsUpdateStatusDialog.vue?vue&type=style&index=0&id=d1711d2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1711d2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1711d2c')) {
      api.createRecord('d1711d2c', component.options)
    } else {
      api.reload('d1711d2c', component.options)
    }
    module.hot.accept("./KidsUpdateStatusDialog.vue?vue&type=template&id=d1711d2c&scoped=true", function () {
      api.rerender('d1711d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/KidsUpdateStatusDialog.vue"
export default component.exports